import * as actions from '../constants'

export const loadFoundIn = () => dispatch=>{
  dispatch({
    type: actions.LOAD_FOUNDIN_REQUEST
  })
  fetch(`${actions.API_ENDPOINT}/pages?title=${encodeURIComponent('FOUND IN 2015')}`).then(res=> {
    return res.json()
  }).then(data=>{
    dispatch({
      type: actions.LOAD_FOUNDIN_SUCCESS,
      payload: data
    })
  }).catch(error=>{
    dispatch({
      type: actions.LOAD_FOUNDIN_FAILURE,
      payload: error.message
    })
  })
}

export const loadFounders = () => dispatch=>{
  dispatch({
    type: actions.LOAD_FOUNDERS_REQUEST
  })
  fetch(`${actions.API_ENDPOINT}/pages?title=${encodeURIComponent('FOUNDERS')}`).then(res=> {
    return res.json()
  }).then(data=>{
    dispatch({
      type: actions.LOAD_FOUNDERS_SUCCESS,
      payload: data
    })
  }).catch(error=>{
    dispatch({
      type: actions.LOAD_FOUNDERS_FAILURE,
      payload: error.message
    })
  })
}

export const loadPartners = () => dispatch=>{
  dispatch({
    type: actions.LOAD_PARTNERS_REQUEST
  })
  fetch(`${actions.API_ENDPOINT}/pages?title=${encodeURIComponent('PARTNERS')}`).then(res=> {
    return res.json()
  }).then(data=>{
    dispatch({
      type: actions.LOAD_PARTNERS_SUCCESS,
      payload: data
    })
  }).catch(error=>{
    dispatch({
      type: actions.LOAD_PARTNERS_FAILURE,
      payload: error.message
    })
  })
}

export const loadContributors = () => dispatch=> {
  dispatch({
    type: actions.LOAD_CONTRIBUTORS_REQUEST
  })
  fetch(`${actions.API_ENDPOINT}/pages?title=${encodeURIComponent('PAST MEMBERS / CONTRIBUTORS')}`).then(res => {
    return res.json()
  }).then(data => {
    dispatch({
      type: actions.LOAD_CONTRIBUTORS_SUCCESS,
      payload: data
    })
  }).catch(error => {
    dispatch({
      type: actions.LOAD_CONTRIBUTORS_FAILURE,
      payload: error.message
    })
  })
}


export const loadShanghai = () => dispatch=>{
  dispatch({
    type: actions.LOAD_SHANGHAI_REQUEST
  })
  fetch(`${actions.API_ENDPOINT}/pages?title=${encodeURIComponent('立入禁止SHANGHAI')}`).then(res=> {
    return res.json()
  }).then(data=>{
    dispatch({
      type: actions.LOAD_SHANGHAI_SUCCESS,
      payload: data
    })
  }).catch(error=>{
    dispatch({
      type: actions.LOAD_SHANGHAI_FAILURE,
      payload: error.message
    })
  })
}

export const loadHA = () => dispatch=>{
  dispatch({
    type: actions.LOAD_HA_REQUEST
  })
  fetch(`${actions.API_ENDPOINT}/pages?title=${encodeURIComponent('HONORS & AWARDS')}`).then(res=> {
    return res.json()
  }).then(data=>{
    dispatch({
      type: actions.LOAD_HA_SUCCESS,
      payload: data
    })
  }).catch(error=>{
    dispatch({
      type: actions.LOAD_HA_FAILURE,
      payload: error.message
    })
  })
}
